import { Oid } from '@ip6m/types';
import { Injectable } from '@nestjs/common';
import { OidDefinition } from '../interfaces/oid';

@Injectable() 
export class OidDB {
    getChildrenOids(oid: OidDefinition){
        const oids: Array<string> = [];

        Object.entries(oid['children']).forEach(([key, value]) => {
             oids.push(oid['base'] + "." + value);
        });
        return oids;
    }
    getChildrenNames(oid: OidDefinition){
        const names: Array<string> = [];

        Object.entries(oid['children']).forEach(([key, value]) => {
             names.push(key);
        });
        return names;
    }

    getNumericOid(oid: OidDefinition, name: string): string {
        return oid.base + '.' + oid.children[name];
    }

    getFullOid(oidDef: OidDefinition, name: string, type: string, value: any, index: number = null): Oid {
        let oid = oidDef.base + '.' + oidDef.children[name];
        if(index) {
            oid = oid + '.' + index;
        }
        return {
            oid: oid,
            type: type,
            value: value
        }
    }
    
    System(): OidDefinition {
        return {
            'base': '1.3.6.1.2.1.1',
            'children': {
                'sysDescr': '1.0',
                'sysObjectID': '2.0',
                'sysUpTime': '3.0',
                'sysContact': '4.0',
                'sysName': '5.0',
                'sysLocation': '6.0',
                'sysServices': '7.0'
            }
        }        
    };
}
